<template>
    <div class="bottom">
        昆山华大智造云影医疗科技有限公司 版权所有  <a href="https://beian.miit.gov.cn">粤ICP备2022090548号-4</a>
    </div>
</template>
<script lang="js">
export default {
    name: 'Bottom'
}
</script>
<style lang="scss" scoped>
.bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 36px;
    line-height: 16px;
    font-size: 14px;
    color: #222222;

    .icon {
        margin: 0 4px;
        font-size: 22px;
    }

    a {
        margin-left: 10px;
        text-decoration: none;
    }
}
</style>
